import BasePage from "../modules/basePage";
import "../modules/searchAlgolia";
import "../../css/pages/SearchAlgoliaPage.scss";

/**
 * Serving as entry point for webpack build.
 * This page imports Algolia modules to this single page JavaScript
 */
class SearchPage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }
    init() {
        super.init();
    }
}

new SearchPage();
